export default __webpack_public_path__ + "static/media/helmet.aced622d.svg";